import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import EditprofileComp from "./editprofileComp";
import ChangepswdComp from "./changepswdComp";
import { useNavigate } from "react-router-dom";
import { Select, Space } from "antd";
import { getRole, isLoggedIn, notify } from "../../utils/utils";

const Setting = () => {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState("editprofile");
  const handleSelectChange = (value) => {
    setActiveFilter(value);
    if (["user", "pattern", "doctype"].includes(value)) {
      navigate(`/${value}listing`);
    }
  };

  useEffect(() => {
    console.log(isLoggedIn())
    
    if(!isLoggedIn() ){
      // navigate("/login");
      notify("Session expired", "error");
      window.location.href = "/login"
    }
  }, []);
  return (
    <>
      <div className="settings-main-container">
        <h2 className="text-medium-black text-center">Settings</h2>
        <div className="setting-inner d-flex">
          <div className="setting-left-mobil d-none ">
            <Space wrap>
              <Select
                className="edit-profile-dropdown"
                defaultValue="editprofile"
                style={{ width: "100%" }}
                options={[
                  { value: "editprofile", label: "Edit Profile" },
                  { value: "changepswd", label: "Change Password" },
                  { value: "user", label: "User" },
                  { value: "doctype", label: "Document Type" },
                ]}
                onChange={handleSelectChange}
              />
            </Space>
          </div>
          <div className="setting-left d-flex flex-column">
            <div
              className={`left-options v-center space-between ${
                activeFilter === "editprofile" ? "active" : ""
              }`}
              onClick={() => setActiveFilter("editprofile")}
            >
              <h6>Edit Profile</h6>
              <Icon icon="mingcute:right-fill" width={20} height={20} />
            </div>
            <div
              className={`left-options v-center space-between ${
                activeFilter === "changepswd" ? "active" : ""
              }`}
              onClick={() => setActiveFilter("changepswd")}
            >
              <h6>Change Password</h6>
              <Icon icon="mingcute:right-fill" width={20} height={20} />
            </div>

            {getRole() === "admin" && (
              <div
                className="left-options v-center space-between"
                onClick={() => {
                  navigate("/userlisting");
                }}
              >
                <h6>User</h6>
                <Icon icon="mingcute:right-fill" width={20} height={20} />
              </div>
            )}

            <div
              className="left-options v-center space-between"
              onClick={() => {
                navigate("/doctypelisting");
              }}
            >
              <h6>My Document</h6>
              <Icon icon="mingcute:right-fill" width={20} height={20} />
            </div>
          </div>
          <div className="setting-right">
            {activeFilter === "editprofile" && <EditprofileComp />}
            {activeFilter === "changepswd" && <ChangepswdComp />}
          </div>
        </div>
      </div>
    </>
  );
};

export default Setting;
